module.exports = __webpack_public_path__ + "static/img/ylsb.7a9cddad.jpg";